import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';

export const Searchbar = ({
  searchQuery,
  setSearchQuery,
}: {
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
}) => {
  return (
    <Search>
      <SearchInputContainer>
        <SearchInput
          spellCheck={false}
          type="text"
          placeholder="Search"
          value={searchQuery}
          onInput={(e: ChangeEvent<HTMLInputElement>) =>
            setSearchQuery(e.target.value)
          }
        />
        <i className="searchIcon icon-search" />
        {searchQuery && (
          <i
            className="clearIcon icon-not-visible"
            onClick={() => setSearchQuery('')}
          />
        )}
      </SearchInputContainer>
    </Search>
  );
};

const Search = styled.div`
  display: flex;
  margin-bottom: 10px;

  & > i {
    width: 25px;
    height: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    color: var(--text-color-secondary);
  }
`;

const SearchInputContainer = styled.div`
  width: 100%;
  position: relative;

  & > i {
    position: absolute;
    top: 0;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5px;

    color: var(--text-color-secondary);
    font-size: 12px;
  }

  .searchIcon {
    font-size: 14px;
  }

  .clearIcon {
    cursor: pointer;
    right: 0;

    &:hover {
      color: var(--text-color);
    }
  }
`;

const SearchInput = styled.input`
  box-sizing: border-box;
  width: 100%;
  height: 30px;

  background-color: var(--panel-bg-color);
  border: none;
  border-radius: 15px;
  padding: 0 35px;

  color: var(--text-color-secondary);
  font-size: 12px;

  &:focus {
    outline: none;
    color: var(--text-color);
  }
`;
